<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Order Pembelian</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Pembelian / Order Pembelian</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          icon="pi pi-plus"
          label="Order Pembelian"
          class="mr-2"
          @click="onAddPO()"
        />
        <Button
          type="button"
          icon="pi pi-refresh"
          label="Reset"
          class="p-button-outlined"
          @click="clearFilter()"
        />
      </div>
      <fx-table
        ref="table"
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        :filters="filters"
        @request="onRequestData"
        @sort="onSort($event)"
      >
        <template #columns>
          <Column style="min-width: 3rem; flex: initial" header="" expander>
          </Column>
          <Column
            field="pr_no"
            header="NO Order"
            style="min-width: 15rem"
            :showFilterMenu="false"
            sortable
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="pr_date"
            header="Tgl Order"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #body="{ data }">
              {{ formatDate(data.pr_date) }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <CalendarFilter
                ref="calendarFilter"
                v-model="filterModel.value"
                showButtonBar
                :numberOfMonths="2"
                @select="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="supplier.name"
            header="Supplier"
            sort-field="supp_name"
            filterField="supplier"
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="status"
            header="status"
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #body="{ data }">
              <div :class="'status-badge status-' + data.status">
                {{ data.status }}
              </div>
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                @change="filterCallback()"
                :options="list_status"
                optionValue="value"
                optionLabel="label"
                class="p-column-filter"
              >
              </Dropdown>
            </template>
          </Column>
          <Column
            field="cost"
            header="GRAND TOTAL"
            style="min-width: 12rem; justify-content: flex-end"
            class="grand-total__table"
            :showFilterMenu="false"
          >
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.cost, 2, 2 || 0) }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <InputNumber
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder=""
                locale="id-ID"
                :min="0"
                :maxFractionDigits="2"
                :minFractionDigits="0"
                @input="filterModel.value = $event.value"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column style="flex-grow: 1; justify-content: flex-end">
            <template #body="{ data }">
              <Button
                type="button"
                icon="pi pi-print"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onPrint(data)"
                :disabled="data.status != 'done'"
              />
              <Button
                type="button"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="generateCSV(data)"
                :disabled="data.status != 'done'"
              />
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onEditData(data)"
              />
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-outlined p-button-danger p-button-text"
                @click="onConfirmDeletion(data)"
                :disabled="data.status == 'done'"
              />
            </template>
          </Column>
        </template>
      </fx-table>
    </div>
    <Dialog
      header="Hapus Order Pembelian"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Order Pembelian <strong>{{ form.pr_no }}</strong> akan dihapus.
          Proses ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeletePurchaseOrder"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import PurchaseOrderService from '@/services/PurchaseOrderService'
import FxTable from '@/components/pembelian/GridPo'
import CalendarFilter from '@/components/CalendarFilter.vue'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { FilterMatchMode } from 'primevue/api'
import { formatCurrency, formatDate } from '@/helpers/index'
import { saveAs } from 'file-saver'

export default {
  name: 'PurchaseOrder',
  components: {
    CalendarFilter,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      purchaseOrderService: null,
      dialogHapus: false,
      isLoading: false,
      isLoadingSave: false,
      items: [],
      form: {},
      PurchaseOrder: [],
      list_status: [
        { value: 'draft', label: 'Draft', level: 0 },
        { value: 'done', label: 'Done', level: 1 },
      ],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: '-pr_date',
        sortOrder: '1',
        filters: null,
      },
      filters: {
        cost: { value: null, matchMode: FilterMatchMode.CONTAINS },
        taxv: { value: null, matchMode: FilterMatchMode.CONTAINS },
        disc_ext: { value: null, matchMode: FilterMatchMode.CONTAINS },
        disc_reg: { value: null, matchMode: FilterMatchMode.CONTAINS },
        bruto: { value: null, matchMode: FilterMatchMode.CONTAINS },
        pr_no: { value: null, matchMode: FilterMatchMode.CONTAINS },
        pr_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        supplier: { value: null, matchMode: FilterMatchMode.EQUALS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
      pdfSource: '',
      pdfFilename: '',
      pdfTitle: 'PDF Viewer ',
      dialogViewer: false,
    }
  },
  watch: {
    'options.filters'(value) {
      // custom Forcibly delete calendar data because it can't be deleted by default
      if (!value.pr_date.value) {
        this.$refs.calendarFilter.clearValueOnly()
      }
    },
  },
  created() {
    this.purchaseOrderService = new PurchaseOrderService()
  },
  async mounted() {
    this.loadData()
  },
  methods: {
    onAddPO() {
      if (localStorage.getItem('purchaseOrder') !== null) {
        localStorage.removeItem('purchaseOrder')
      }
      this.$router.push({ name: 'PurchaseOrderAdd' })
    },
    clearFilter() {
      if (this.$refs.calendarFilter != undefined) {
        this.$refs.calendarFilter.clearValueOnly()
      }
      if (this.$refs.table != undefined) {
        this.$refs.table.initFilters()
      }
    },
    formatCurrency(val, minDigit = 2, maxDigit = 2) {
      return formatCurrency(val, minDigit, maxDigit)
    },
    formatDate(value) {
      return formatDate(value)
    },
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.purchaseOrderService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data
          this.totalRecords = res.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Order Pembelian', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onSort(e) {
      this.options.value = e
      this.loadData()
    },
    onPrintData(data) {
      this.purchaseOrderService
        .print(data.id)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'PurchaseOrder.pdf')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Print Order Pembelian', this)
        })
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onPrint(data) {
      this.purchaseOrderService
        .print(data.id)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const pdfUrl = URL.createObjectURL(blob)
          this.pdfSource = pdfUrl + '#toolbar=0'
          this.pdfFilename = 'purchase-order.pdf'
          this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
          this.dialogViewer = true
        })
        .catch((err) => {
          errorHandler(err, 'Print Order Pembelian', this)
        })
    },
    generateCSV(data) {
      if (data.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Purchase Order',
          detail: 'Item PO masih kosong.',
          life: 3000,
        })
        return
      }

      const csvContent = this.convertToCSV(data)
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'po.csv')
      link.click()
    },
    convertToCSV(data) {
      let po = []
      let po_obj = {
        no: data.pr_no,
        date: data.pr_date,
        supplier_code: data.supplier['supp'],
        supplier_name: data.supplier['name'],
        supplier_fax: data.supplier['fax'],
      }
      po.push(po_obj)

      let poitem = []
      data.details.forEach((item) => {
        let obj = {
          barcode: "'" + item.item_barcode_1,
          deskripsi: item.item_name,
          isi: item.ubox,
          qty_b: item.qty_b,
          unit_b: item.unit_b,
          qty_s: item.qty_s,
          unit_s: item.unit_s,
          harga: Number(item.cost || 0).toFixed(2),
          per: item.cost_per,
          disc_ext: Number(item.disc_ext || 0).toFixed(2),
          disc_extv: Number(item.disc_extv || 0).toFixed(2),
          disc_reg: Number(item.disc_reg || 0).toFixed(2),
          disc_regv: Number(item.disc_regv || 0).toFixed(2),
          dpp: Number(item.dpp || 0).toFixed(2),
        }
        poitem.push(obj)
      })

      const headpo = Object.keys(po[0])
      const povalue = po.map((po_obj) => headpo.map((header) => po_obj[header]))

      const headers = Object.keys(poitem[0])
      const rows = poitem.map((obj) => headers.map((header) => obj[header]))
      // const headerRow = headers.join(';')
      const csvRows = [
        headpo,
        ...povalue.map((row) => row),
        '',
        headers,
        ...rows.map((row) => row),
      ]
      return csvRows.join('\n')
    },
    onEditData(data) {
      this.$router.push({ name: 'PurchaseOrderEdit', params: { id: data.id } })
    },

    onConfirmDeletion(data) {
      this.form = data
      this.dialogHapus = true
    },
    onDeletePurchaseOrder() {
      this.purchaseOrderService
        .delete(this.form.id)
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast.add({
              severity: 'success',
              summary: 'Data Order Pembelian',
              detail: 'Data berhasil dihapus.',
              life: 3000,
            })
            this.loadData()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Data Order Pembelian', this)
        })
      this.form = {}
      this.dialogHapus = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.$router.push({ name: 'PurchaseOrderAdd' })
      }
    },
    /* onToggle(value) {
      this.selectedColumns = this.columns.filter((col) => value.includes(col))
    }, */
  },
}
</script>
